import { LevelFormatConverter } from '../LevelFormatConverter';
import { GRID_CONSTANTS } from '../constants/GridConstants';
import type { GridLevel } from '../TileEditorTypes';
import { resolveTownPropAttachment } from '../scene/townPropTemplates';
import { validateTownPropAttachments, type TownMountProp, type TownMountWorld } from '../scene/townPropAttachments';

/** Both map formats are checked against the geometry they actually load, never an original pre-rasterized roof. */
export function validateMountedSceneProps(level: unknown): Array<{ field: string; message: string; severity: 'error' }> {
  if (!level || typeof level !== 'object') return [];
  const source = level as { width?: number; height?: number; widthTiles?: number; heightTiles?: number; tileSize?: number;
    platforms?: TownMountWorld['platforms']; layers?: GridLevel['layers']; scene?: { natureProps?: TownMountProp[] } };
  const props = source.scene?.natureProps;
  if (!Array.isArray(props) || !props.some(p => resolveTownPropAttachment(p?.kind ?? '', p?.template) !== 'ground')) return [];
  let world: TownMountWorld = { width: source.width!, height: source.height!, platforms: source.platforms };
  if (Array.isArray(source.layers)) {
    const tileSize = source.tileSize ?? GRID_CONSTANTS.TILE_SIZE;
    world = { width: source.widthTiles! * tileSize, height: source.heightTiles! * tileSize, platforms: [] };
    const validDimensions = [source.widthTiles, source.heightTiles, tileSize]
      .every(n => typeof n === 'number' && Number.isFinite(n) && n > 0);
    if (!validDimensions) world = { width: NaN, height: NaN, platforms: [] };
    else try {
      const normalized = { ...source, layers: source.layers.map(layer => ({ ...layer,
        tiles: layer.tiles instanceof Map ? layer.tiles : new Map(Object.entries(layer.tiles ?? {})),
      })) } as unknown as GridLevel;
      world.platforms = LevelFormatConverter.gridToPlatformer(normalized).platforms;
    } catch { /* malformed editor geometry cannot supply a ceiling */ }
  }
  return validateTownPropAttachments(props, world).map(error => ({
    field: `scene.natureProps[${error.index}]`, message: error.message, severity: 'error' as const,
  }));
}
